import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss'],
})
export class ShareModalComponent  implements OnInit {
  @Input() refreshMyData?: () => Promise<void>;

  constructor(private modalCtrl: ModalController,
              private translate: TranslateService
  ) { }

  ngOnInit() {}

  // Fechar modal
  dismiss() {
    this.modalCtrl.dismiss();
  }

  async triggerShare() {
    if (this.refreshMyData) {
      await this.refreshMyData();
    }
  }

}
